import assessmentTypes from "@/view/constants/assessmentTypes";

const getAttachmentsFilteredByLicense = (
  attachments,
  canViewPowerWords,
  canViewChecksForUnderstanding = true,
  canViewGuidedHighlighting = true,
) => {
  return attachments?.filter((attachment) => {
    const shouldHideActivity =
      (attachment.content_type === assessmentTypes.POWER_WORDS_ACTIVITY.type &&
        !canViewPowerWords) ||
      (attachment.content_type ===
        assessmentTypes.CHECKS_FOR_UNDERSTANDING_QUIZ.type &&
        !canViewChecksForUnderstanding) ||
      (attachment.content_type ===
        assessmentTypes.GUIDED_HIGHLIGHTING_QUIZ.type &&
        !canViewGuidedHighlighting);

    return !shouldHideActivity;
  });
};

export default getAttachmentsFilteredByLicense;
